export class CustomerOrderDto {
  orderId: number;
  orderCreatedDate: Date;
  orderTotalPrice: number;
  merchantId: number;
  merchantName: string;
  brandId: number;
  customerId: number;
  currencyId: number;
  currencyCode: string;
  loyaltyPoints: number;
  stamps: number;
}
